(function() {
    'use strict';

    angular
        .module('telestatApp')
        .controller('VirtualNumberDialogController', VirtualNumberDialogController);

    VirtualNumberDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'VirtualNumber', 'CloudPBX'];

    function VirtualNumberDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, VirtualNumber, CloudPBX) {
        var vm = this;

        vm.virtualNumber = entity;
        vm.clear = clear;
        vm.datePickerOpenStatus = {};
        vm.openCalendar = openCalendar;
        vm.save = save;
        vm.cloudpbxes = CloudPBX.query();

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.virtualNumber.id !== null) {
                VirtualNumber.update(vm.virtualNumber, onSaveSuccess, onSaveError);
            } else {
                VirtualNumber.save(vm.virtualNumber, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('telestatApp:virtualNumberUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }

        vm.datePickerOpenStatus.lastActionTime = false;

        function openCalendar (date) {
            vm.datePickerOpenStatus[date] = true;
        }
    }
})();
